import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How much does it cost?",
    a: "Every job is quoted free and individually, based on the size of your grounds and what's needed — there's no call-out charge and no obligation.",
  },
  {
    q: "How often will you visit?",
    a: "Whatever suits you — weekly, fortnightly or monthly maintenance plans, or a one-off visit. We'll recommend a routine that keeps your grounds looking their best.",
  },
  {
    q: "What's included?",
    a: "All cuttings and clippings are tidied up and taken away, leaving your space clean and neat. We're a friendly, fully insured local team and we take pride in every job.",
  },
  {
    q: "Which areas do you cover?",
    a: "We're based in Washington and cover Sunderland, Durham, Gateshead and the surrounding North East of England.",
  },
  {
    q: "Do I need to be home?",
    a: "Not necessarily — as long as we have safe access to your grounds. We'll always confirm the arrangements with you beforehand.",
  },
  {
    q: "How do I get started?",
    a: "Just fill in the quote form or give us a call on 07770 347944. We'll get back to you with a free, no-obligation quote.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const FAQ = () => {
  return (
    <section id="faq" className="relative bg-brand-surface py-24 md:py-36">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-4"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-brand-orange" />
              <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
                FAQs
              </span>
            </div>
            <h2 className="font-heading font-medium tracking-tight text-white text-4xl md:text-5xl leading-[1.05]">
              Good to know.
            </h2>
            <p className="text-white/60 font-body mt-6 leading-relaxed">
              The quick answers most people ask before booking. Still unsure?
              Give us a call on{" "}
              <a href="tel:07770347944" className="text-brand-orange hover:underline">07770 347944</a>.
            </p>
          </motion.div>

          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-white/10"
                >
                  <AccordionTrigger className="text-left font-heading text-white text-lg md:text-xl hover:text-brand-orange hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 font-body text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
